@if (profile | async; as p) {
  <div class="app-general-infos d-flex">
    @if (p.account; as account) {
      <div class="d-flex align-items-center">
        <fa-icon class="me-3" size="3x" icon="user-circle"></fa-icon>
        <div class="h-85px">
          <p class="fw-bold">Mon contact commercial &nbsp;@if (showTooltip) {
            <fa-icon
              ngbTooltip="Pour toute demande de mise à jour, démonstration, demande de devis ou planification de prestations, nous vous invitons à contacter votre commercial."
            icon="info-circle"></fa-icon>
          }
        </p>
        @if (account.commercial; as commercial) {
          <div>
            <p>Mr {{ commercial.firstname }} {{ commercial.lastname }}</p>
            <p>
              <a href="mailto:{{commercial.email}}">{{ commercial.email }}</a>
              <fa-icon class="ms-2 cursor-pointer" icon="copy" ngbTooltip="Copier l'adresse mail dans le presse-papier" appCopy="E-mail" [text]="commercial.email"/>
            </p>
            <p>
              <a href="tel:{{commercial.phone}}">{{ commercial.phone }}</a>
              <fa-icon class="ms-2 cursor-pointer" icon="copy" ngbTooltip="Copier le numéro dans le presse-papier" appCopy="Numéro" [text]="commercial.phone"/>
            </p>
          </div>
        } @else {
          <div class="d-flex align-items-center">Aucun contact commercial associé</div>
        }
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center">Aucun compte associé</div>
  }
</div>
} @else {
  <div class="app-general-infos d-flex align-items-center">
    <ls-spinner/>
  </div>
}




